module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "main-area"
  }, [_c('b-row', {
    attrs: {
      "align-h": "around"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "2"
    }
  }, [_c('sidebar')], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "10"
    }
  }, [_c('b-container', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f01707e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/Profile.vue
// module id = 235
// module chunks = 1